import { useContext, useEffect } from "react";

import { BaseLayout } from "components/base-layout";
import { FetchingError } from "components/common/fetching-error";
import { Stack } from "components/common/stack";
import { SubmitClaim } from "components/renderers";
import { ClaimActivity } from "components/renderers/claim-activity";
import { ClaimHelpSection } from "components/renderers/claim-help-section/claim-help-section";
import { AuthAppContext } from "components/root/auth-app-provider";
import { MainLayout } from "components/shared/main-layout";
import { useClaimsList } from "data/ss-data-hooks";
import { scrollToTop, trackEvent } from "utils";

const THIRD_PARTY_CLAIM_TRACKERS = ["vave", "markel"];

const Claims = () => {
  const { userPolicyProperties } = useContext(AuthAppContext);
  const { error, isLoading, data: claimsList } = useClaimsList();

  useEffect(() => {
    trackEvent("Claims");
    scrollToTop();
  }, []);

  if (error) {
    return (
      <BaseLayout>
        <MainLayout sidebar={<ClaimHelpSection />}>
          <FetchingError page="Claims" />
        </MainLayout>
      </BaseLayout>
    );
  }

  const claimTrackedInternally = !THIRD_PARTY_CLAIM_TRACKERS.includes(
    userPolicyProperties?.carrierGroup?.toLowerCase() ?? ""
  );

  const main = (
    <Stack>
      <SubmitClaim
        hasClaims={!!claimsList?.ClaimsTrackerInfo}
        carrierGroup={userPolicyProperties?.carrierGroup ?? ""}
      />
      {claimsList?.ClaimsTrackerInfo ? (
        <ClaimActivity
          claims={claimsList.ClaimsTrackerInfo ?? []}
          claimTrackedInternally={claimTrackedInternally}
        />
      ) : null}
    </Stack>
  );

  return (
    <BaseLayout
      availableNotifications={["HomeServices", "CancellationPayment"]}
    >
      <MainLayout sidebar={<ClaimHelpSection />} mainLoading={isLoading}>
        {main}
      </MainLayout>
    </BaseLayout>
  );
};

export default Claims;
